import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const tutorialDescription: ThemedFunctor = ({ theme }) => css`
  gap: ${theme.remSize[150]};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  height: 100%;
`;
